import CalendarLocale from 'rc-calendar/lib/locale/zh_CN';

const locale = {
  lang: Object.assign({ placeholder: '请选择日期', rangePlaceholder: ['开始日期', '结束日期'] }, CalendarLocale),
  timePickerLocale: {},
};
// should add whitespace between char in Button
locale.lang.ok = '确 定';
export default locale;
